// const getAvailabilityV11 = (locations: any) => {
//   try {
//     if (locations.length === 0) {
//       throw new Error('location data unavailable');
//     }
//     const data = locations[0];
//     const dayjs = useDayjs();
//     const dateNow = dayjs().format('YYYY-MM-DD');
//     const result: any = {
//       days: data?.availability?.days || data?.time?.days?.split(',').map((k: string) => Number(k)),
//       holidays: data?.availability?.holidays || data?.time?.holidays || [],
//       times: []
//     };
    
//     if (result.times.length === 0 && data.time?.schedule) {
//       const { frequency, times } = data?.time?.schedule;
//       if (frequency && times) {
//         if(times && times.length > 0) {
//           times.forEach((item: any) => {    
//             result.times.push({
//               start: Number(item),
//               end: Number(dayjs(`${dateNow} ${item}`, 'YYYY-MM-DD HHmm').add(dayjs.duration(frequency).asSeconds(), 'seconds').format('HHmm'))
//             })
//           })
//         }
//       }
//     }

//     if (result.times.length === 0 && data.availability) {
//       const { time } = data.availability
//       if (time && time.length > 0) {
//         time.forEach((item: any) => {    
//           result.times.push({
//             start: Number(item.start),
//             end: Number(item.end)
//           })
//         })
//       }  
//     }

//     if (result.times.length === 0 && data.time) {
//       const { range } = data?.time;
//       if (range && range.start && range.end) {
//         result.times = [{
//           start: Number(range.start),
//           end: Number(range.end)
//         }];
//       }
//     }

//     if (result.times.length === 0) {
//       result.times = [{ start: 0, end: 2359 }];
//     }

//     const { days, times, holidays } = result;
//     const date = dayjs().format('DD-MM-YYYY');
//     const day = Number(dayjs().isoWeekday());

//     const holidayCheck = !(holidays && holidays.includes(date));
//     const dayCheck = days ? days.includes(day) : true;
    
//     let isOpened = holidayCheck && dayCheck;
//     const hhmm = Number(dayjs().format('HHmm'));
//     let isTimeOpened = false;
//     times.forEach((item: any) => {
//       isTimeOpened = isTimeOpened || (hhmm >= item.start && hhmm <= item.end);
//     });
//     isOpened = isOpened && isTimeOpened;
//     let nextAvailTime = 0;
//     if (!isOpened) {
//       times.forEach((item: any, index: any) => {
//         if (item.start >= hhmm && nextAvailTime === 0) {
//           nextAvailTime = index;
//         }
//       });
//     }
//     const [start, end] = times[nextAvailTime].start?.toString().padStart(4, '0').match(/.{1,2}/g);
//     const opensAt = dayjs().add(0, 'day').hour(start).minute(end).format('hh:mm A');

//     if (locations.length > 0) {
//       if (locations[0].time.label) {
//         const isClosed = ['close', 'disable'].includes(locations[0].time.label.toLowerCase());
//         if (isClosed) {
//           isOpened = 0;
//         }
//       }
//     }
//     return { is_opened: Number(isOpened), opens_at: opensAt };
//   } catch (err: any) {
//     console.log('timing error: ', err.message);
//     return { is_opened: 1, opens_at: undefined };
//   }
// };

const getAvailability = (data: any) => {
  const dayjs = useDayjs();
  const dayNow = Number(dayjs().isoWeekday());
  const dateNow = dayjs().format('YYYY-MM-DD');
  const timeNow = Number(dayjs().format('HHmm'));
  let isOpened = 0;

  const { time, holidays } = data;
  try {
    const deliveryTiming = time.filter((k: any) => k.type?.toLowerCase() === 'delivery' && k.day === dayNow);
    const orderTiming = time.filter((k: any) => k.type?.toLowerCase() === 'order' && k.day === dayNow);
    const pickupTiming = time.filter((k: any) => k.type?.toLowerCase() === 'self-pickup' && k.day === dayNow);
    const timingToBeChecked = [...deliveryTiming, ...orderTiming];
    if (timingToBeChecked.length === 0) {
      timingToBeChecked.push(...pickupTiming);
    }
    for (const t of timingToBeChecked) {
      // if (timeNow > t.start && timeNow < t.end) {
      //   isOpened = 1;
      //   break;
      // }
      if ((t.start < t.end && timeNow >= t.start && timeNow <= t.end) || 
          (t.start > t.end && (timeNow >= t.start || timeNow <= t.end))) {
        isOpened = 1;
        break;
      }
    }
    const nextDay = Number(dayjs().add(1, 'day').isoWeekday())
    const nextDayDeliveryTiming = time.filter((k: any) => k.day === nextDay);
    return {
      isOpened: isOpened && !(holidays && holidays.includes(dateNow)),
      timeArray: timingToBeChecked,
      nextTimeArray: nextDayDeliveryTiming,
    }
  } catch (error: any) {
    console.log('timing error: ', error.message);
    return { isOpened: 1, timeArray: [] };
  }
};

export const useTimingCheck = (data: any, locations: any) => {  
  // if (!data) {
  //   return getAvailabilityV11(locations);
  // }
  const isUpdated = data.time.filter((k: any) => k.type && k.day);
  if (isUpdated.length === 0) {
    // return getAvailabilityV11(locations);
    return { is_opened: true }
  }
  const dayjs = useDayjs();  
  const availability = getAvailability(data); 
  const { isOpened, timeArray, nextTimeArray } = availability;
  let isOpenedNow = isOpened;
  const timeNow = Number(dayjs().format('HHmm'));
  let nextAvailTime = -1;
  if (!isOpenedNow) {
    timeArray.forEach((item: any, index: any) => {
      if (item.start >= timeNow && nextAvailTime === -1) {
        nextAvailTime = index;
      }
    });
  }
  let opensAt = undefined;
  if (nextAvailTime > -1) {
    const [hh, mm] = timeArray[nextAvailTime].start?.toString().padStart(4, '0').match(/.{1,2}/g);
    opensAt = dayjs().add(0, 'day').hour(hh).minute(mm).format('hh:mm A');
  } else if (nextTimeArray && nextTimeArray.length > 0) {
    const sorted = nextTimeArray.sort((a: any, b: any) => a.start - b.start);
    const [hh, mm] = sorted[0].start?.toString().padStart(4, '0').match(/.{1,2}/g);
    opensAt = `${dayjs().add(0, 'day').hour(hh).minute(mm).format('hh:mm A')}`;
  } else {
    opensAt = undefined;
  }

  // for (const location of locations) {
  //   if (location.time?.label.toLowerCase() === 'close') {
  //     isOpenedNow = false;
  //     opensAt = undefined;
  //   }
  // }
  return {
    is_opened: isOpenedNow,
    opens_at: opensAt
  }
};
